module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zZW0Fm/tc-custom/9781960332691.jpg?1721404701829",
      "alt": "This image is the cover for the book Gabardine Gang"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Gabardine Gang\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("THE GABARDINE GANG: Power and Betrayal in Hartford's Mob Scene by Kevin B. DiBacco is a riveting tale of crime, family, and redemption in the gritty underworld of the 1950s and 1960s Hartford, Connecticut.      Geno DiBacco led the notorious Gabardine Gang, a small-time mob that ruled the city. Geno's son, Kevin, takes you on a visceral journey through his childhood and adolescence, revealing the gang's illegal activities, his father's dramatic descent, and the harsh realities of organized crime, offering a unique perspective on a world often glamorized in Hollywood.      This book offers a profound look at the DiBacco family's struggles amid racial tensions and the personal costs of a life entwined with crime. Geno's battle with gambling addiction and the impact of his choices on his family paint a vivid picture of a man and a community at a crossroads.     THE GABARDINE GANG explores the intricate dynamics of family, resilience, and personal redemption. Kevin's authentic storytelling immerses readers in a world where every twist and turn resonates with genuine emotion.     Don't miss your chance to experience this raw and unfiltered exploration of a bygone era.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kevin B. DiBacco\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    WildBlue Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0